var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHappiness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101,
    height: 124,
    viewBox: "0 0 101 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "happiness_svg__a",
    d: "M0 46.665C0 20.893 20.89 0 46.672 0c25.776 0 46.672 20.896 46.672 46.665v16.051c0 25.772-20.692 49.6-46.21 53.218l-.462.066-.462-.066C20.689 112.315 0 88.485 0 62.716V46.665z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "happiness_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#happiness_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    stroke: "currentColor",
    strokeWidth: 6.344,
    xlinkHref: "#happiness_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 4.531,
    d: "M65.005 30.789c.006 4.945 5.58 8.961 12.451 8.97",
    mask: "url(#happiness_svg__b)",
    transform: "rotate(150 71.23 35.274)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 4.531,
    d: "M15.21 30.789c.007 4.945 5.581 8.961 12.451 8.97",
    mask: "url(#happiness_svg__b)",
    transform: "scale(1 -1) rotate(-30 -110.208 0)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 4.196,
    d: "M42.594 75.219a3.625 3.625 0 003.625 3.625h0a3.625 3.625 0 003.625-3.625",
    mask: "url(#happiness_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 4.531,
    d: "M66.156 54.375a4.531 4.531 0 004.531 4.531h0a4.531 4.531 0 004.532-4.531M18.125 54.375a4.531 4.531 0 004.531 4.531h0a4.531 4.531 0 004.532-4.531",
    mask: "url(#happiness_svg__b)",
    transform: "matrix(1 0 0 -1 0 113.281)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 4.896,
    d: "M36.25 90.22c0 5.229 4.869 9.468 10.875 9.468S58 95.448 58 90.22c0 0-7.295-.501-10.875-.501-3.67 0-10.875.501-10.875.501z",
    mask: "url(#happiness_svg__b)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappiness);
export default __webpack_public_path__ + "static/media/happiness.e10dc0eb.svg";
export { ForwardRef as ReactComponent };